<template>
	<div v-if="webinar">
		<layout :mastheadBackgroundImage="mastheadBg">
			<div slot="masthead" class="center">
				<masthead>
					<template slot="headline">{{ webinar.title }}</template>
					<template slot="content">{{ webinarTime }}</template>
				</masthead>
			</div>
			<div class="content" slot="body">
				<FormLayout>
					<div class="content__info" slot="info">
						<ul class="secondary-info">
							<li>
								<h4>StudySync</h4>
								<p>E: <a href="mailto:info@studysync.com">info@studysync.com</a></p>
							</li>
						</ul>
					</div>
					<div class="layout__form" slot="form">
						<div class="agenda" v-if="webinar.agenda">
							<p>{{ webinar.agenda }}</p>
						</div>
						<WebinarForm v-bind="{ webinar }" />
					</div>
				</FormLayout>
			</div>
		</layout>
		<FooterCTA />
	</div>
</template>

<script>

	import moment from 'moment'
	import Layout from '@/layouts/layoutA'
	import Masthead from '@/layouts/layoutA/masthead'
	import FormLayout from '@/layouts/FormLayout'
	import WebinarForm from '@/components/WebinarForm'
	import FooterCTA from '@/components/FooterCTA'
	import localTimeZoneAbbrev from '@/utilities/localTimeZoneAbbrev'

	export default {
		metaInfo () {
			return {
				title: (this.webinar) ? `Register for ${this.webinar.title} with StudySync` : ''
			}
		},
		routeConfig: {
			path: 'register/:webinarId'
		},
		data () {
			return {
				mastheadBg: require('img/mastheads/subscribe1.jpg')
			}
		},
		components: { Layout, Masthead, FormLayout, WebinarForm, FooterCTA },
		async created () {
			try {
				await this.$store.dispatch('entities/webinar/fetchOne', +this.$route.params.webinarId)
			} catch (e) {
				this.$router.push({ name: 'webinars', query: { statusCode: 404 } })
			}
		},
		computed: {
			webinar () {
				return this.$store.getters['entities/webinar/find'](+this.$route.params.webinarId)
			},
			webinarTime () {
				const { webinar } = this
				if(webinar) {
					const start = moment(webinar.startTime).format('dddd, LL h:mm A')
					const end = moment(webinar.endTime).format('h:mm A')
					return `${start} - ${end} ${localTimeZoneAbbrev()}`
				}
				return null
			}
		},
	}
</script>

<style lang="scss" scoped>

	@import "responsive-font";
	@import "list-style-reset";
	@import "media";

	.content {
		@include responsive-font(10);
		@include media(small,xlarge) {
			background:#F6F8F9; padding-bottom:3em;
			& > * {
				padding-top:3em;
			}
		}
		@include media(xlarge) {
			& > * {
				background:#F6F8F9;
			}
		}

		.secondary-info {
			@include list-style-reset;
			@include responsive-font(18);
			color:#6D6E71;
			li + li {
				margin-top:2em;
			}
			h4 {
				@include responsive-font(12);
				font-family:'proxima-nova'; font-weight:600; letter-spacing:.075em; text-transform:uppercase; color:#FDB913;
			}
			p {
				margin:.25em 0 0;
			}
			a {
				color:inherit;
			}
		}
	}

	.agenda {
		@include responsive-font(18);
		margin-bottom:3rem;
	}

</style>



// WEBPACK FOOTER //
// src/routes/webinars/register.vue